<template>
	<footer class="page-footer font-small indigo">

    <div class="footer-copyright text-center py-3">
      <div class="float-right">
        <a href="https://blackbozz.com" target="_blank">
          <img src="https://blackbozz.com/logo.png" class="b-logo">
        </a>
      </div>
    
      <strong>V:{{version}}</strong> |  CashFactoring - {{$t('footer.rights')}}
    </div>
    <!-- Copyright -->

  </footer>
</template>


<script>
import Vue from "vue";
import { VERSION } from "@/common/config";

export default Vue.extend({
  name: "app-footer",
  data: function() {
    return {
      version: VERSION
    };
  },

  methods: {}
});
</script>


<style>
footer {
  overflow: hidden;
  margin-top: 30px;
  background: #fff;

  .logo {
    padding: 50px;
    max-width: 100%;
  }
}
.b-logo {
  height: 60px;
}
</style>
